import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import axios from "axios";
import BASE_URL from "../../../../constants/baseUrls";
import { toast } from "react-toastify";
import { LocaleContext } from "../../../../routing/LangRouter";
import { useTranslation } from "react-i18next";
import { navigateToLoginPage } from "../../../../utils/utility";
import { IS_MOBILE } from "../../../../constants/breakpoints";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";
import QuestionModal from "../../../common/question-modal/question-modal";
import EmptyOrErrorState from "../../../common/empty-or-error-state/empty-or-error-state";

//import images and icons
import { CloseCircle, InfoCircle, TickCircle } from "iconsax-react";

//import styles
import "swiper/css";
import "swiper/css/pagination";

function CardContainer({ cardItem, handleDeleteChange }) {
    const { t } = useTranslation();

    return (
        <Grid className="bank-account-information__flip-card" container item xs={12} alignItems="flex-start" my={1}>
            <Grid className="flip-card-inner" container item xs={12}>
                <Grid className="flip-card-front" container item xs={12}>
                    <Grid className="bank-account-information__header" container item xs={12} justifyContent="space-between">
                        <img
                            className="bank-account-information__header--logo"
                            src={"https://api.atripa.com" + cardItem.bank.logo}
                            alt={cardItem.bank.name}
                        />
                        {IS_MOBILE ? (
                            <svg
                                className="bank-account-information__header--background"
                                xmlns="http://www.w3.org/2000/svg"
                                width="111"
                                height="59"
                                viewBox="0 0 111 59"
                                fill="none"
                            >
                                <defs>
                                    <linearGradient id={cardItem.card_number}>
                                        <stop offset="5%" stopColor={cardItem.bank.color_first} />
                                        <stop offset="95%" stopColor={cardItem.bank.color_last} />
                                    </linearGradient>
                                </defs>
                                <path
                                    d="M0 17.8094V47.5008C131.523 80.6083 118.875 29.8002 96.1342 0.426223C69.7587 0.426223 21.6198 -0.449356 16.1236 0.309375C2.76405 2.1536 0 16.3679 0 17.8094Z"
                                    fill={`url(#${cardItem.card_number})`}
                                />
                                <text className="bank-account-information__header--text" x="90%" y="50%" fill="white">
                                    {cardItem.bank.name}
                                </text>
                            </svg>
                        ) : (
                            <svg
                                className="bank-account-information__header--background"
                                width="198"
                                height="129"
                                viewBox="0 0 198 129"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <defs>
                                    <linearGradient id={cardItem.card_number}>
                                        <stop offset="5%" stopColor={cardItem.bank.color_first} />
                                        <stop offset="95%" stopColor={cardItem.bank.color_last} />
                                    </linearGradient>
                                </defs>
                                <path
                                    d="M0 18.1737V104.829C235.898 178.555 212.797 66.1629 172.009 0.750929C124.703 0.750929 27.4099 -0.938662 17.552 0.750929C1.50445 3.50137 0 14.9637 0 18.1737Z"
                                    fill={`url(#${cardItem.card_number})`}
                                />
                                <text className="bank-account-information__header--text" x="90%" y="50%" fill="white">
                                    {cardItem.bank.name}
                                </text>
                            </svg>
                        )}
                    </Grid>
                    <Grid className="bank-account-information__body" container item xs={12}>
                        <Grid className="bank-account-information__info" container item xs={12} rowGap={1}>
                            <Grid container item xs={12} justifyContent="center">
                                <span>{cardItem.card_number}</span>
                            </Grid>
                            <Grid container item xs={12} justifyContent="space-between">
                                <span>{t("accountNumber")}:</span>
                                <span>{cardItem.account_number}</span>
                            </Grid>
                            <Grid container item xs={12} justifyContent="space-between">
                                <span>{t("shebaNumber")}:</span>
                                <span>IR{cardItem.sheba_number}</span>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className="flip-card-back" container item xs={12}>
                    <Grid className="bank-account-information__header" container item xs={12} justifyContent="space-between">
                        {IS_MOBILE ? (
                            <svg
                                className="bank-account-information__header--background"
                                xmlns="http://www.w3.org/2000/svg"
                                width="111"
                                height="59"
                                viewBox="0 0 111 59"
                                fill="none"
                            >
                                <defs>
                                    <linearGradient id={cardItem.card_number}>
                                        <stop offset="5%" stopColor={cardItem.bank.color_first} />
                                        <stop offset="95%" stopColor={cardItem.bank.color_last} />
                                    </linearGradient>
                                </defs>
                                <path
                                    d="M110.562 18.1188V47.8103C-20.9616 80.9178 -8.31318 30.1097 14.4275 0.735671C40.803 0.735671 88.9419 -0.139907 94.4382 0.618823C107.798 2.46305 110.562 16.6773 110.562 18.1188Z"
                                    fill={`url(#${cardItem.card_number})`}
                                />
                                <text className="bank-account-information__header--text" x="90%" y="50%" fill="white">
                                    {cardItem.bank.name}
                                </text>
                            </svg>
                        ) : (
                            <svg
                                className="bank-account-information__header--background"
                                width="198"
                                height="129"
                                viewBox="0 0 198 129"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <defs>
                                    <linearGradient id={cardItem.card_number}>
                                        <stop offset="5%" stopColor={cardItem.bank.color_first} />
                                        <stop offset="95%" stopColor={cardItem.bank.color_last} />
                                    </linearGradient>
                                </defs>
                                <path
                                    d="M198 18.1737V104.829C-37.8984 178.555 -14.7967 66.1629 25.9907 0.750929C73.2975 0.750929 170.59 -0.938662 180.448 0.750929C196.496 3.50137 198 14.9637 198 18.1737Z"
                                    fill={`url(#${cardItem.card_number})`}
                                />
                                <text className="bank-account-information__header--text" x="90%" y="50%" fill="white">
                                    {cardItem.bank.name}
                                </text>
                            </svg>
                        )}
                        <img
                            className="bank-account-information__header--logo"
                            src={"https://api.atripa.com" + cardItem.bank.logo}
                            alt={cardItem.bank.name}
                        />
                    </Grid>
                    <Grid
                        className="bank-account-information__status"
                        container
                        item
                        xs={12}
                        columnGap={1}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <span>{t("status")}:</span>
                        {cardItem.confirmed ? (
                            <span className="bank-account-information__confirmed">
                                {t("General.Approved")}
                                <TickCircle color="var(--green-color)" variant="Bold" />
                            </span>
                        ) : (
                            <span className="bank-account-information__not-confirmed">
                                {t("General.Not Approved")}
                                <CloseCircle color="var(--red-color)" variant="Bold" />
                            </span>
                        )}
                    </Grid>
                    <Grid container item xs={5} md={3} justifyContent="center" alignItems="center" mx="auto">
                        <BaseButton
                            text={t("User Panel.Delete Card")}
                            color="red"
                            size="small"
                            radius="radius-10"
                            handleClick={() => handleDeleteChange(cardItem?.id)}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

function BankCardList({ cardList, getCardList }) {
    //general
    const location = useLocation();
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const accessToken = localStorage.getItem("accessToken");
    const { t } = useTranslation();

    //delete card
    const [isOpenQuestionModal, setIsOpenQuestionModal] = useState(false);
    const [cardId, setCardId] = useState("");
    const handleDeleteChange = id => {
        setCardId(id);
        setIsOpenQuestionModal(true);
    };

    const deleteCard = async () => {
        try {
            const response = await axios.delete(`${BASE_URL}/account/user/bank_account/`, {
                params: {
                    pk: cardId,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            toast.success(response.data.data.detail, { toastId: "custom-id-yes" });
            setIsOpenQuestionModal(false);
            getCardList();
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
            } else toast.error(error.response.data.errors.detail, { toastId: "custom-id-yes" });

            setIsOpenQuestionModal(false);
        }
    };

    return (
        <>
            {cardList?.length ? (
                <>
                    {IS_MOBILE ? (
                        cardList.map(cardItem => {
                            return (
                                <Grid container item xs={12}>
                                    <CardContainer cardItem={cardItem} handleDeleteChange={handleDeleteChange} />
                                </Grid>
                            );
                        })
                    ) : (
                        <Swiper
                            dir="rtl"
                            modules={[Pagination]}
                            className="mySwiper"
                            breakpoints={{
                                0: {
                                    slidesPerView: 1.1,
                                    spaceBetween: 15,
                                },
                                900: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 30,
                                },
                            }}
                        >
                            {cardList.map(cardItem => {
                                return (
                                    <SwiperSlide key={cardItem.id}>
                                        <CardContainer cardItem={cardItem} handleDeleteChange={handleDeleteChange} />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    )}
                </>
            ) : (
                <Grid container item xs={8}>
                    <EmptyOrErrorState
                        title={t("Messages.No Card Registered")}
                        icon={<InfoCircle size="32" color="var(--secondary-color)" variant="Bold" />}
                        marginBottom={0}
                    />
                </Grid>
            )}
            <QuestionModal
                open={isOpenQuestionModal}
                setOpen={setIsOpenQuestionModal}
                question={t("Messages.Confirm Card Deletion")}
                colorYes="blue-gray"
                colorNo="teal-18"
                handleClick={deleteCard}
            />
        </>
    );
}

export default BankCardList;
